import { Routes } from '@angular/router';
import { ChatWindowComponent } from './components/chat-window/chat-window.component';
import { Login } from './components/login/login';
import { LoginCallback } from './components/login-callback/login-callback';
import { LoginError } from './components/login-error/login-error';
import { Supervisor } from './components/supervisor/supervisor';
import { Unauthorized } from './components/unauthorized/unauthorized';
import { authGuard } from './services/auth-guard';
import { RoleSelect } from './components/role-select/role-select';
import { NoAssignment } from './components/no-assignment/no-assignment';
import { NoEntry } from './components/no-entry/no-entry';

export const routes: Routes = [
    {
        path: '',
        component: Login,
        // data: { showHeader: false, showFooter: false },
        pathMatch: 'full',
    },
    {
        path: 'login',
        component: Login,
        // data: { showHeader: false, showFooter: false },
        pathMatch: 'full',
    },
    {
        path: 'auth-callback',
        component: LoginCallback,
        // data: { showHeader: false, showFooter: false },
        pathMatch: 'full',
    },
    {
        path: 'login-error',
        component: LoginError,
        // data: { showHeader: false, showFooter: false },
        pathMatch: 'full',
    },
    {
        path: 'unauthorized',
        component: Unauthorized,
        pathMatch: 'full',
    },
    {
        path: 'no-entry',
        component: NoEntry,
        pathMatch: 'full',
    },
    {
        path: 'role-select',
        component: RoleSelect,
        // canActivate: [authGuard],
        pathMatch: 'full',
    },
    {
        path: 'no-assignment',
        component: NoAssignment,
        canActivate: [authGuard],
        data: { roles: ['flms', 'flm'] },
        pathMatch: 'full',
    },
    {
        path: 'chat',
        component: ChatWindowComponent,
        canActivate: [authGuard],
        data: { roles: ['flms', 'flm'] },
        // data: { showHeader: false, showFooter: false },
        pathMatch: 'full',
    },
    {
        path: 'review',
        component: Supervisor,
        canActivate: [authGuard],
        data: { roles: ['supervisors', 'supervisor', 'riskofficers', 'riskofficer'] },
        pathMatch: 'full'
    },
];
